const RiskMoney = [
    {id: "0", value: "高獲利"},    
    {id: "1", value: "中獲利"},
    {id: "2", value: "低獲利"},
    {id: "3", value: "虧損"},      
  ];  
  
  export default RiskMoney